import axios from 'axios'
import { api_url } from '../config'
import { createBrowserHistory } from 'history'
import { message } from 'antd'
import { store } from '../Components/Redux/store'
import userService from './userService'

const history = createBrowserHistory()
const apiClient = axios.create({
  baseURL: api_url,
})

apiClient.interceptors.request.use(
  config => {
    const _u = JSON.parse(store.getState().user.user)
    const token = _u?.sessionToken
    const accountId = _u?.accountId
    // console.log('token', token, 'id', accountId)
    config.headers['accept'] = 'application/json'
    if (token) {
      config.headers['x-access-token'] = token
      config.headers['Authorization'] = "JWT " + token
    }
    if (accountId) {
      config.headers['x-access-user'] = accountId
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  response => {
    return response.data
  },
  async error => {
    if (error.response?.data?.message) {
      message.destroy()
      message.error(error.response?.data?.message)
    }

    if (error.response?.status === 401) {
      message.destroy()
      message.error(error.response?.data?.message)
      userService.removeLocalStorage()
      history.push('/login')
      return Promise.reject(error)
    }
    if (error.response?.status === 403) {
      message.destroy()
      message.error(error.response?.data?.message)
      userService.removeLocalStorage()
      history.push('/login')
      return Promise.reject(error)
    }
    console.log(error)
    return Promise.reject(error)
  }
)

export default apiClient
